import * as React from "react";
import "./Users.scss";
import { TableUsersAnalytics } from './TableUsersAnalytics';
import { AnalyticsUserDetail } from './AnalyticsUserDetail';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_ANALYTICS } from 'src/component/shared';

import {
    Card,
    CardContent,
    IconButton,
    TextField,
    Tooltip,
    LinearProgress,
    CardHeader
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import * as Moment from 'moment';
import { CurrentDate, SomeDaysAgo } from "src/services";

export const ANALYTICS_USER_FILTER = gql`
query analyticsUsersFilter($customFilter:  AnalyticsCustomFilter) {
    analyticsUsersFilter(analyticsCustomFilter: $customFilter) {
    email
  }
  analyticsUsersFilterChecked @client
}
`;

// tslint:disable-next-line:no-empty-interface
export interface IUsersProps {
    errorMessage(error:string): void,
}

// tslint:disable-next-line:no-empty-interface
export interface IUsersState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    endDate: any,
    initialDate: any,
    isDetail: boolean,
    user: any
}

export class Users extends React.Component<IUsersProps, IUsersState> {

    constructor(props: IUsersProps) {
        super(props);
        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            endDate: undefined,
            initialDate: undefined,
            isDetail: false,
            user: {}
        }
        this.changeDate = this.changeDate.bind(this);
        this.requestByDate = this.requestByDate.bind(this);
        this.setDetailState = this.setDetailState.bind(this);
        this.handleBackToList = this.handleBackToList.bind(this);
    }

    public componentWillMount () {
        const finalDate = CurrentDate();
        const initDate = SomeDaysAgo(7);
        this.changeDate(initDate, finalDate);
    }
    
    public render() {

        const jsonFilter = {
            "customFilter": {
                "isChart": true
            }
        };
      
        return (
            <Query query={QUERY_FILTER_ANALYTICS} notifyOnNetworkStatusChange={true}  >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC }) => (
                <Query query={ANALYTICS_USER_FILTER} variables={QueryFilter.getFilterAnalytics(clientC, jsonFilter, [], false)}>
                {({ loading, error, data}) => {
                    return (
                        <div className='analyticsUserTab'>
                            <Card>
                                <form onSubmit={this.requestByDate}>
                                    <CardContent>
                                        <div className="analytical-date">
                                            <TextField
                                                defaultValue={this.state.initialDate}
                                                id="initialDate"
                                                label="Data inicial"
                                                type="date"
                                                required={true}
                                                InputLabelProps={{
                                                shrink: true,
                                                }}
                                            />
                                        </div>
            
                                        <TextField
                                            defaultValue={this.state.endDate}
                                            id="endDate"
                                            label="Data final"
                                            type="date"
                                            required={true}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <IconButton type="submit"  color="primary" >
                                            <Tooltip title="Pesquisar">
                                                <SendIcon/>
                                            </ Tooltip>
                                        </IconButton>
                                    </CardContent>
                                </form>
                            </Card>
                            { loading ?  
                                <LinearProgress /> : 
                                <Card>
                                    {
                                        this.state.isDetail ? 
                                            <CardHeader className='detailCardHeader'
                                                title={
                                                    <div className='detailCardHeaderTitle'>
                                                        <IconButton type="submit" color='inherit'  onClick={this.handleBackToList} >
                                                            <Tooltip title="Voltar">
                                                                <KeyboardArrowLeftIcon />
                                                            </ Tooltip>
                                                        </IconButton>
                                                        <span>{this.state.user.dimensions[0]}</span>
                                                    </div>
                                                } 
                                            /> : 
                                            null
                                    }
                                    <CardContent>
                                        {
                                            !this.state.isDetail ? 
                                            <TableUsersAnalytics endDate={this.state.endDate} initialDate={this.state.initialDate} 
                                                errorMessage={this.props.errorMessage} userEmailArray={data && data.analyticsUsersFilter 
                                                && data.analyticsUsersFilter.length > 0 ? data.analyticsUsersFilter : []}
                                                setDetailState={this.setDetailState} />
                                            :
                                            <AnalyticsUserDetail setDetailState={this.setDetailState} endDate={this.state.endDate} initialDate={this.state.initialDate} 
                                                errorMessage={this.props.errorMessage} email={this.state.user.dimensions[0]} />
                                        }
                                    </CardContent>
                                </Card>
                            }
                        </div>
                    );
                }}
                </Query>
            )}
            </Query>
        );
    }

    private handleBackToList () {
        this.setDetailState(false, {});
    }

    private setDetailState(isDetail:boolean, user:any) {
        this.setState({isDetail, user});
    }

    /**
     * Métodos consulta por data
     */
    private requestByDate(ev: any) {
        ev.preventDefault();

        const diference = Moment(ev.target.endDate.value,'YYYY-MM-DD')
            .diff(Moment(ev.target.initialDate.value, 'YYYY-MM-DD'), 'days');

        if(diference<=90) {
            this.changeDate(ev.target.initialDate.value, ev.target.endDate.value);
        } else {
            this.setState({
                alertOpened: true,
            });
            this.props.errorMessage('O intervalo limite de data para pesquisa é de 90 dias');
        }
    }

    /**
     * Métodos auxiliares do processo
     */
    private changeDate (init: any, end: any) {
        this.setState({initialDate:init, endDate:end});
    }

}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/tabs/users/Users.tsx